import { CampaignId } from '../schema/CampaignId';
import { PlacementId } from '../schema/PlacementId';
import type { MiniHostAppCampaign } from '../schema/MiniHostAppCampaign';

export const outlookLiteCampaignConfigs: MiniHostAppCampaign[] = [
    // Allowed placements (Surfaces)
    PlacementId.MiniOnboardingCardsCarousel,
    PlacementId.MiniMailSurface,

    // Allowed campaign instances
    CampaignId.MiniOnboardingTryM365,
    CampaignId.MiniNewUserWelcomeScreen,
    CampaignId.LiteInAppReview,
    CampaignId.LiteTryAddAnotherAccount,
];
